export default "__VITE_ASSET__307dd1e2__"